import React, { useState, useEffect } from "react";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import { RevenueCharts } from "./DashboardEcommerceCharts";
import SafeCountUp from "../../Components/Common/SafeCountUp";
import { useSelector, useDispatch } from "react-redux";
import { getRevenueChartsData } from "../../slices/thunks";
import { fetchSales } from "../../utils/dashboard";  
import { ToastContainer, toast } from 'react-toastify';
import { createSelector } from "reselect";

const Revenue = () => { 

  const [chartData, setchartData] = useState([]);
  const [revenue, setRevenue] = useState({}); 
  const[loading, setLoading] = useState(false);
  const [dateList, setDateList] = useState([]);
  
  const errornotify = (error) => toast(error, { position: "top-center", hideProgressBar: true, closeOnClick: false, className: 'bg-danger text-white' });
  const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  useEffect(() => {  
    loadDashboardData(); 
  }, []);
  // const selectDashboardData = createSelector(
  //   (state) => state.DashboardEcommerce,
  //   (revenueData) => revenueData.revenueData
  // );
  // // Inside your component
  // const revenueData = useSelector(selectDashboardData);

  // useEffect(() => {
     
  //   setchartData(revenueData);
  // }, [revenueData]);

const loadDashboardData = async (pType) => {
    try {
      setLoading(true);
      let startDate, endDate = new Date();
      
      // 根据时间段类型计算日期范围
      switch(pType) {
        case 'year':
          startDate = new Date();
          startDate.setFullYear(endDate.getFullYear() - 1);
          break;
        case 'halfyear':
          startDate = new Date();
          startDate.setMonth(endDate.getMonth() - 6);
          break;
        case 'month':
          startDate = new Date();
          startDate.setMonth(endDate.getMonth() - 1);
          break;
        default: // all
          startDate = new Date('2000-01-01'); // 默认最早日期
      }

      const params = {
        start_date: formatDate(startDate),
        end_date: formatDate(endDate)
      };

      const response = await fetchSales(params); 
      if(response && response.status === 200 && response.data){  
        const revenue = response.data?.data?.revenue || {};
        setRevenue(revenue); 
        const series = [
          {
            name: "Sales Amount",
            type: "line",
            data: (revenue.data || []).map(item => parseFloat(item.sales_amount) || 0)
          },
          {
            name: "Total Orders",
            type: "line",
            data: (revenue.data || []).map(item => parseInt(item.total_orders) || 0)
          },
          {
            name: "Cancelled Orders",
            type: "line",
            data: (revenue.data || []).map(item => parseInt(item.cancelled_orders) || 0)
          }
        ];
        const dateList = (revenue.data || []).map(item => item.date || '');
        setDateList(dateList);
        setchartData(series);
        console.log("chartData",series)
        setLoading(false);
        }else {
          const errorMessage = response?.message || 'Failed to load revenue data. The API might be unavailable.';
          errornotify(errorMessage);
          console.error('Revenue API Error:', response);
          setLoading(false);
          
          // Set empty data to prevent errors
          setRevenue({});
          setchartData([]);
          setDateList([]);
        }
      } catch (error) {
          console.error('Error loading revenue data:', error);
          errornotify(error.message || 'An unexpected error occurred while loading revenue data');
          setLoading(false);
          
          // Set empty data to prevent errors
          setRevenue({});
          setchartData([]);
          setDateList([]);
      }
 };
 const onChangeChartPeriod = pType => {

   loadDashboardData(pType) 
 };
  // useEffect(() => {
  //   dispatch(getRevenueChartsData("all"));
  // }, [dispatch]);
  return (
    <React.Fragment>
      <Card>
        <CardHeader className="border-0 align-items-center d-flex">
          <h4 className="card-title mb-0 flex-grow-1">Revenue</h4>
          <div className="d-flex gap-1">
            <button type="button" className="btn btn-soft-secondary btn-sm" onClick={() => { onChangeChartPeriod("all"); }}>
              ALL
            </button>
            <button type="button" className="btn btn-soft-secondary btn-sm" onClick={() => { onChangeChartPeriod("month"); }}>
              1M
            </button>
            <button type="button" className="btn btn-soft-secondary btn-sm" onClick={() => { onChangeChartPeriod("halfyear"); }}>
              6M
            </button>
            <button type="button" className="btn btn-soft-primary btn-sm" onClick={() => { onChangeChartPeriod("year"); }}>
              1Y
            </button>
          </div>
        </CardHeader>

        <CardHeader className="p-0 border-0 bg-light-subtle">
          <Row className="g-0 text-center">
          <Col xs={4} sm={4}>
              <div className="p-3 border border-dashed border-start-0">
                <h5 className="mb-1">
                  <SafeCountUp 
                    start={0} 
                    end={(revenue.data || []).reduce((acc, item) => acc + (item.sales_amount || 0), 0)} 
                    duration={3} 
                    separator=","
                  />
                </h5>
                <p className="text-muted mb-0">Sales Amount</p>
              </div>
            </Col>
            <Col xs={4} sm={4}>
              <div className="p-3 border border-dashed border-start-0">
                <h5 className="mb-1">
                  <SafeCountUp
                    suffix="k"
                    prefix="$"
                    start={0}
                    decimals={2}
                    end={(revenue.data || []).reduce((acc, item) => acc + (item.total_orders || 0), 0)} 
                    duration={3}
                  />
                </h5>
                <p className="text-muted mb-0">Total Orders</p>
              </div>
            </Col>
            
            <Col xs={4} sm={4}>
              <div className="p-3 border border-dashed border-start-0 border-end-0">
                <h5 className="mb-1 text-success">
                  <SafeCountUp
                    start={0}
                    end={
                      (() => {
                        const cancelled_orders = (revenue.data || []).reduce((acc, item) => acc + (item.cancelled_orders || 0), 0);
                        const totalOrders = (revenue.data || []).reduce((acc, item) => acc + (item.total_orders || 0), 0);
                        return cancelled_orders > 0 ? (cancelled_orders / totalOrders * 100) : 0;
                      })()
                    }
                    decimals={2}
                    duration={3}
                    suffix="%"
                    delay={250}
                  />
                </h5>
                <p className="text-muted mb-0">Order Cancellation Rate</p>
              </div>
            </Col>
          </Row>
        </CardHeader>

        <CardBody className="p-0 pb-2">
          <div className="w-100">
            <div dir="ltr">
            {loading ? (
              <div className="text-center p-3">Loading charts...</div>
            ) : (
              <RevenueCharts series={chartData} dateList={dateList} dataColors='["#45CB85", "--vz-primary", "--vz-info"]' />
            )}
            </div>
          </div>
            <div className="table-responsive " >
              <table className="table table-borderless table-centered align-middle table-nowrap mb-0">
                  <thead className="text-muted table-light">
                      <tr> 
                          <th scope="col">date</th>
                          <th scope="col">cancelled orders</th>
                          <th scope="col">sales amount</th>
                          <th scope="col">total orders</th> 
                      </tr>
                  </thead>
                 {loading ? (
                   <tbody>
                     <tr>
                       <td colSpan="4" className="text-center">Loading...</td>
                     </tr>
                   </tbody>
                 ) : (
                   <tbody>
                      {(revenue.data || []).map((item, key) => (<tr key={key}>  
                          <td>{item.date}</td> 
                          <td>{item.cancelled_orders}</td>
                          <td> {item.sales_amount.toFixed(2)} </td> 
                          <td> {item.total_orders}</td> 
                      </tr>))}
                  </tbody>
                 )} 
              </table>
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default Revenue;
